import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("D:/code/peergroup/layouts/default.vue"))
}